import React from 'react';
import PropTypes from 'prop-types';
import './saveAndCancelButtons.less';
import { Translate } from '@above-the-treeline/localization';
import { Button } from 'antd';

SaveAndCancelButtons.propTypes = {
	onSave: PropTypes.func,
	onCancel: PropTypes.func,
};

function SaveAndCancelButtons({ onSave, onCancel }) {
	return (
		<div className="save-and-cancel-buttons">
			<Button size="small" onClick={onSave}>
				<Translate id="save" />
			</Button>
			<Button size="small" onClick={onCancel}>
				<Translate id="cancel" />
			</Button>
		</div>
	);
}

export default SaveAndCancelButtons;
